export default __webpack_public_path__ + "static/media/avatar_2.51b4d95e.png";